import { useQuery } from "@tanstack/react-query";

import { checkout } from "src/services";
import { CheckoutError } from "src/types/error";

const useCheckout = (token: string) => {
  const { data, isLoading, error } = useQuery<CheckoutType, CheckoutError>({
    queryKey: ["checkout", token],
    queryFn: () => checkout(token),
    retry: false,
    enabled: !!token,
    staleTime: 0,
    gcTime: 1000 * 60,
    refetchOnWindowFocus: true,
  });

  const showError = error ? error.statusCode !== 404 : false;

  return { data, isLoading, error, showError };
};

export default useCheckout;
